import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const redisCloud = defineConnector({
  identifier: "redisCloud",
  name: "Redis Cloud",
  tagLine: "Managed Redis database service",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.redislabs\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "x-api-key", value: app.secret.accountKey },
      { name: "x-api-secret-key", value: app.secret.userKey },
    ]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your Redis Cloud console, navigate to **Access Management > API Keys** and create a new API key. You'll need both the Account Key and User Key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Account key",
          required: true,
          target: { kind: "secrets", field: "accountKey" },
          helperText: "Your Redis Cloud account key",
        },
        {
          kind: "input",
          label: "User key",
          required: true,
          target: { kind: "secrets", field: "userKey" },
          helperText: "Your Redis Cloud user key (API secret)",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.redislabs.com/v1/subscriptions",
  },
});
